var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradeB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 5.5,
    fill: "#FFF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 23V10.4H17.26C18.148 10.4 18.88 10.544 19.456 10.832C20.044 11.108 20.482 11.492 20.77 11.984C21.058 12.464 21.202 13.004 21.202 13.604C21.202 14.42 20.98 15.062 20.536 15.53C20.104 15.998 19.582 16.322 18.97 16.502C19.438 16.586 19.864 16.772 20.248 17.06C20.632 17.348 20.932 17.708 21.148 18.14C21.376 18.572 21.49 19.046 21.49 19.562C21.49 20.198 21.334 20.78 21.022 21.308C20.71 21.824 20.248 22.238 19.636 22.55C19.024 22.85 18.28 23 17.404 23H12.832ZM14.344 15.908H17.152C17.956 15.908 18.574 15.722 19.006 15.35C19.438 14.966 19.654 14.438 19.654 13.766C19.654 13.13 19.438 12.62 19.006 12.236C18.586 11.852 17.95 11.66 17.098 11.66H14.344V15.908ZM14.344 21.74H17.242C18.106 21.74 18.772 21.542 19.24 21.146C19.708 20.738 19.942 20.174 19.942 19.454C19.942 18.746 19.696 18.182 19.204 17.762C18.712 17.33 18.046 17.114 17.206 17.114H14.344V21.74Z",
    fill: "#EA580C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 5.5,
    stroke: "#FED7AA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradeB);
export default __webpack_public_path__ + "static/media/grade_b.4496637ce7f4a10d35c5dfa45778353b.svg";
export { ForwardRef as ReactComponent };